import Vue from 'vue'
import { make } from 'vuex-pathify'

const state = {
    loaders: {}
}

const getters = {
    loading: (state) => (name) => !!state.loaders[name]
}

const mutations = {
    ...make.mutations(state),

    CREATE_LOADER(state, name) {
        Vue.set(state.loaders, name, 1)
    },

    ADD_LOADER(state, name) {
        Vue.set(state.loaders, name, state.loaders[name] + 1)
    },

    SUB_LOADER(state, name) {
        Vue.set(state.loaders, name, state.loaders[name] - 1)
    },

    DELETE_LOADER(state, name) {
        delete state.loaders[name]
    }
}

const actions = {
    load(context, name) {
        if (context.state.loaders[name]) {
            context.commit('ADD_LOADER', name)
        } else {
            context.commit('CREATE_LOADER', name)
        }
    },

    unload(context, name) {
        if (context.state.loaders[name]) {
            context.commit('SUB_LOADER', name)

            if (context.state.loaders[name] == 0) {
                context.commit('DELETE_LOADER', name)
            }
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
